import React, { createContext } from "react";
import { Link } from "react-router-dom";

import "./Cover.css";
import png350 from "../../images/Cover/CoverPump350.png";
import png500 from "../../images/Cover/CoverPump500.png";
// import png640 from "../../images/HomeCoverPump.svg";

function Cover(props) {
  return (
    <div className="cover">
        <div className="cover__img">
        {/* {props.windowWidth < 350
          ? <img className="cover__img-img" src={png350}/>
          : props.windowWidth < 500
            ? <p>pizda</p>
            // <img className="cover__img-img" src={png500}/>
            : <p>hui</p>
        } */}
        </div>
        <div className="cover__txt">
          <p className="cover__txt-header">
            НАДЕЖНЫЕ И ПРОСТЫЕ РЕШЕНИЯ!
          </p>
          <p className="cover__txt-paragr">
            Насосные агрегаты для водного хозяйства, нефтегазовой,
            нефтехимической и других сфер промышленности
          </p>
        </div>
    </div>
  );
}

export default Cover;

//styleName: Desktop/Headline 1;
